import styled from 'styled-components';

const ButtonsBar = styled.div`
  display: flex;
  margin-top: ${(props): string => props.theme.spaces.xxl};

  > button {
    width: 22rem;
    margin-left: ${(props): string => props.theme.spaces.lg};

    :first-child {
      margin-left: auto;
    }
  }
`;

export { ButtonsBar };
